import { createFileRoute } from '@tanstack/react-router';

import { UsersImporterPage } from '@/areas/settings/OrganizationSettings/pages/UsersImporterPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/organization/users/importer')({
    staticData: { access: { permissions: ['edit:user:organization'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <UsersImporterPage />;
}
